(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-post"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    localStorage.removeItem('selectedTag')
    localStorage.removeItem('applyTagOnLoad')
//     // Apply saved filter instantly on blog list page
//     let storedTag = localStorage.getItem('selectedTag');
//     if (storedTag) {
//         let selectedTagLower = storedTag.toLowerCase();

//         // Simulate tag click to apply UI and filtering
//         $('.header_blogs_post ul li').each(function () {
//             if ($(this).text().trim().toLowerCase() === selectedTagLower) {
//                 $(this).trigger('click');
//             }
//         });
//     }
});

//   $(document).ready(function () {
//     let applyFilter = localStorage.getItem('applyTagOnLoad');
//     let storedTag = localStorage.getItem('selectedTag');

//     if (applyFilter === 'true' && storedTag) {
//         let selectedTagLower = storedTag.toLowerCase();

//         // Simulate tag click to apply UI and filtering
//         $('.header_blogs_post ul li').each(function () {
//             if ($(this).text().trim().toLowerCase() === selectedTagLower) {
//                 // $(this).trigger('click');
//             }
//         });

//         // Clear the flag so it doesn't run on future visits
//         localStorage.removeItem('applyTagOnLoad');
//     }
// });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos-continuesly"] && !Shopify.designMode) return;
  try {
    
class mdMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.madcha-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    console.log(list)
    const marqueeWidth = list.scrollWidth
    console.log(list.scrollWidth)
    const marqueeLength = list.querySelectorAll('li').length 

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #madcha-marquee-${this.dataset.sectionId} ul {
          animation-name: madcha-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes madcha-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes madcha-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('madcha-marquee', mdMarquee)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template--article"]) return;
  try {
    
  $('#backToCategory').on('click', function () {
    localStorage.setItem('applyTagOnLoad', 'true');
});

  } catch(e) { console.error(e); }
})();
})();
